import { Pressable, PressableProps, View, ViewProps } from "react-native";
import React, { Children, createContext, useContext, useState } from "react";
import { Text } from "@ui-kitten/components";
import { useFetchTenantBrandingQuery } from "queries/tenant.queries";

interface TabsContext {
  activeTabIndex: number;
  setActiveTabIndex: React.Dispatch<React.SetStateAction<number>>;
}

interface TabListProps extends ViewProps {
  tabs: string[];
  onTabPress?: (index: number) => void;
  activeTabStyle?: ViewProps["style"];
}
const TabsContext = createContext<TabsContext>({
  activeTabIndex: 0,
  setActiveTabIndex: () => {},
});

const Tabs: React.FC<ViewProps> = (props) => {
  const { children, ...restProps } = props;
  const [activeTabIndex, setActiveTabIndex] = useState(0);
  return (
    <TabsContext.Provider value={{ activeTabIndex, setActiveTabIndex }}>
      <View {...restProps}>{children}</View>
    </TabsContext.Provider>
  );
};

const TabList: React.FC<TabListProps> = (props) => {
  const { setActiveTabIndex, activeTabIndex } = useContext(TabsContext);
  const { data: branding } = useFetchTenantBrandingQuery();
  const { className, onTabPress, activeTabStyle, ...restProps } = props;
  return (
    <View
      className={
        "flex flex-row w-full bg-white p-1 rounded-full mb-10 overflow-x-auto " +
        className
      }
      {...restProps}
    >
      {props.tabs.map((tab, index) => {
        const isSelected = index === activeTabIndex;

        return (
          <Pressable
            className="flex-grow rounded-full p-3"
            key={index}
            onPress={() => {
              onTabPress && onTabPress(index);
              setActiveTabIndex(index);
            }}
            style={[
              {
                backgroundColor: isSelected
                  ? branding?.secondaryColor
                  : "white",
              },
              isSelected && activeTabStyle ? activeTabStyle : undefined,
            ]}
          >
            <Text
              status={isSelected ? "control" : "basic"}
              style={{ textAlign: "center" }}
            >
              {tab}
            </Text>
          </Pressable>
        );
      })}
    </View>
  );
};
const TabPanels: React.FC<{ children: React.ReactElement[] }> = (props) => {
  const arrayChildren = Children.toArray(props.children);
  const { activeTabIndex } = useContext(TabsContext);
  return (
    <>
      {Children.map(arrayChildren, (child, index) => (
        <View
          key={index}
          style={{ display: index === activeTabIndex ? "flex" : "none" }}
        >
          {child}
        </View>
      ))}
    </>
  );
};

const TabPanel: React.FC<{ children: React.ReactElement }> = (props) => {
  return props.children;
};

export default Tabs;
export { TabList, TabPanels, TabPanel };
